import React, {useEffect, useState, useRef} from "react";
import "../../sass/main.scss";
import CmnCard from "../CmnCard";
import axios from "axios";
import $ from 'jquery';
import axios2 from "../../helpers/APIHelper";
import Fn from "../../libraries/Fn";
import Modal from "react-modal";
import _ from "lodash";

const AnalysisSubsCal = (props) => {

  window._load = (_page = 1) => {
    try {
      load(_page);
    } catch (e) {
    }
  }

  const total_days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  const [year, setYear] = useState(Fn.parseInt(Fn.getCurrentDate().split("-")[0]));
  const [month, setMonth] = useState(Fn.parseInt(Fn.getCurrentDate().split("-")[1]));
  const [day, setDay] = useState(Fn.parseInt(Fn.getCurrentDate().split("-")[2]));
  const [calendarArray, setCalendarArray] = useState([]);
  const [renew, setRenew] = useState(0);
  const [result, setResult] = useState({});
  const [srchRenew, setSrchRenew] = useState(0);
  // 타이틀을 위한 별도 상태 추가
  const [displayYear, setDisplayYear] = useState(Fn.parseInt(Fn.getCurrentDate().split("-")[0]));
  const [displayMonth, setDisplayMonth] = useState(Fn.parseInt(Fn.getCurrentDate().split("-")[1]));

  // 모달 관련 상태
  const [summaryModalOpen, setSummaryModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [summaryModalData, setSummaryModalData] = useState({});
  const [modalData, setModalData] = useState({});
  const [modalTitle, setModalTitle] = useState("");
  const [modalType, setModalType] = useState("");
  const [selectedDate, setSelectedDate] = useState("");

  // 컴포넌트 상단에 로딩 상태를 관리할 state 추가
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    load();
  }, [renew, srchRenew]);

  // year와 month 상태가 변경될 때마다 displayYear와 displayMonth도 함께 업데이트
  useEffect(() => {
    setDisplayYear(year);
    setDisplayMonth(month);
  }, [year, month]);

  // 로딩 스피너와 배경 딤 처리를 위한 CSS 스타일
  const spinnerStyles = {
    loadingOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // 배경 약간 어둡게
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // 다른 요소들 위에 표시
      flexDirection: 'column'
    },
    spinner: {
      border: '5px solid #f3f3f3',
      borderTop: '5px solid #3498db',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      animation: 'spin 1s linear infinite',
    },
    loadingText: {
      color: 'white',
      marginTop: '15px',
      fontSize: '16px',
      fontWeight: 'bold'
    }
  };

  // keyframes 애니메이션을 위한 스타일 태그 추가
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(styleTag);

    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  const load = () => {
    $("#overlay").detach();
    // 로딩 시작 시 스피너 표시
    setIsLoading(true);

    let pBranchCode = "";
    if (!(Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) >= 8 || localStorage.getItem("USER.systemManageYN") === "Y" || localStorage.getItem("USER.systemAccountYN") === "Y")) {
      // pBranchCode = localStorage.getItem("USER.systemBranchCode") || '_NONE_';
      pBranchCode = localStorage.getItem("USER.systemBranchCode") || '';
    }
    if (Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) < 9 && ($('#s_branch_code option:selected').val() || (pBranchCode || '')) === '') {
      // pBranchCode = "_NONE_";
      pBranchCode = "";
    }

    axios2
      .post(`/subscription/cal/ready?year=${year}&month=${Fn.lpad(month.toString(), 2, "0")}&day=${Fn.lpad(day.toString(), 2, "0")}&s_branch_code=${$('#s_branch_code option:selected').val() || (pBranchCode || '')}`)
      .then((response) => {
        const {code, message, result, pageInfo} = response?.data;
        if (code === 200) {
          if ($('#s_branch_code').html() === '') {
            let optionsHTML = '<option value="">지점 선택</option>';
            result?.branchList?.forEach((list_row) => {
              optionsHTML += `<option value="${list_row.branch_code}" ${pBranchCode === list_row.branch_code ? " selected" : ""}>${list_row.branch_name}</option>`;
            });
            $('#s_branch_code').html(optionsHTML);
          }

          // 윤년 계산
          if (new Date(year, 1, 29).getDate() === 29) {
            total_days[1] = 29;
          }

          const first_yoil = new Date(year, month - 1, 1).toLocaleString('en-US', {weekday: 'long'});
          const last_yoil = new Date(year, month - 1, total_days[month - 1]).toLocaleString('en-US', {weekday: 'long'});

          let td_su, td_su2;

          switch (first_yoil) {
            case 'Sunday':
              td_su = 0;
              break;
            case 'Monday':
              td_su = 1;
              break;
            case 'Tuesday':
              td_su = 2;
              break;
            case 'Wednesday':
              td_su = 3;
              break;
            case 'Thursday':
              td_su = 4;
              break;
            case 'Friday':
              td_su = 5;
              break;
            case 'Saturday':
              td_su = 6;
              break;
          }

          switch (last_yoil) {
            case 'Sunday':
              td_su2 = 6;
              break;
            case 'Monday':
              td_su2 = 5;
              break;
            case 'Tuesday':
              td_su2 = 4;
              break;
            case 'Wednesday':
              td_su2 = 3;
              break;
            case 'Thursday':
              td_su2 = 2;
              break;
            case 'Friday':
              td_su2 = 1;
              break;
            case 'Saturday':
              td_su2 = 0;
              break;
          }

          const start_num = 1 - td_su;
          const end_num = total_days[month - 1] + td_su2;

          const _calendar_array = [];

          for (let i = start_num; i <= end_num; i++) {
            if (i < 1 || i > total_days[month - 1]) {
              _calendar_array[i] = [' ', ' '];
            } else {
              _calendar_array[i] = [i, new Date(year, month - 1, i).toLocaleString('en-US', {weekday: 'long'})];
            }
          }

          setCalendarArray(_calendar_array);
          setResult(result);

          $('.class-cal').remove();

          let output = '';
          let cnt = 1;

          // 현재 날짜 가져오기
          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          const currentMonth = currentDate.getMonth() + 1;
          const currentDay = currentDate.getDate();

          for (let i = start_num; i <= end_num; i++) {
            const value = _calendar_array[i];
            let holy_class = '';

            if (value[1] === 'Sunday' || cnt === 1) {
              if (year === currentYear && month === currentMonth && value[0] === currentDay) {
                holy_class = "class='sunday today'";
              } else {
                holy_class = "class='sunday'";
              }
            } else {
              if (year === currentYear && month === currentMonth && value[0] === currentDay) {
                holy_class = "class='today'";
              } else {
                holy_class = "";
              }
            }

            if (cnt % 7 === 1) {
              output += '<tr class="class-cal">';
            }

            let db_month = month < 10 ? '0' + month : month.toString();
            let db_day = value[0] < 10 ? '0' + value[0] : value[0].toString();
            let today_chk = `${year}-${db_month}-${db_day}`;

            const isPast = today_chk < Fn.getCurrentDate() || (today_chk == Fn.getCurrentDate() && Fn.getCurrentTime() >= '14:00:00');

            holy_class = "scope";

            if (value?.[0] > 0) {
              output += `<td class="${holy_class}"><a href="#" class="cal_date">${value[0]}</a>`;

              // 일자별 구독 결제 정보 표기
              const subsInfo = result?.subsInfo?.[today_chk] || {};
              if (subsInfo) {
                output += `<ul class="px-5 text-left pt-2" style="vertical-align: top;">`;

                if (today_chk >= '2025-04-16') {
                  if (isPast) {
                    output += `<div class="subs-info-container" style="padding: 5px; margin-top: 5px;">
                      <div class="d-flex flex-wrap justify-content-center" style="gap: 2px;">
                        <a href="javascript:void(0)" onClick="window.showSubscriptionSummary('${today_chk}'); return false;" class="btn-sssm btn-outline-point" style="width: 120px; margin: 2px; text-align: center;">전체: ${subsInfo?.totalCount || 0}건</a>
                        <a class="btn-sssm" style="width: 120px; margin: 2px; text-align: center; color: #333333 !important; text-decoration: none;">성공: ${subsInfo?.successCount || 0}건</a>
                        <a class="btn-sssm" style="width: 120px; margin: 2px; text-align: center; color: #333333 !important; text-decoration: none;">중지: ${subsInfo?.failCount || 0}건</a>
                        <a class="btn-sssm" style="width: 120px; margin: 2px; text-align: center; color: #333333 !important; text-decoration: none;">해지: ${subsInfo?.cancelCount || 0}건</a>
                      </div>
                    </div>`;
                  } else {
                    output += `<div class="subs-info-container" style="padding: 5px; margin-top: 5px;">
                      <div class="d-flex flex-wrap justify-content-center" style="gap: 2px;">
                        <a href="javascript:void(0)" onClick="window.showSubscriptionDetail('${today_chk}', 'scheduled'); return false;" class="btn-sssm btn-outline-point" style="width: 120px; margin: 2px; text-align: center;">예정: ${subsInfo?.scheduledCount || 0}건</a>
                        <a href="javascript:void(0)" onClick="window.showSubscriptionDetail('${today_chk}', 'cancel'); return false;" class="btn-sssm btn-outline-danger" style="width: 120px; margin: 2px; text-align: center;">해지: ${subsInfo?.cancelCount || 0}건</a>
                      </div>
                    </div>`;
                  }
                }
              }
            } else {
              output += `<td><a href="#" class="cal_date">${value[0]}</a>`;
            }

            output += '</td>';

            if (cnt % 7 === 0) {
              output += '</tr>';
            }

            cnt++;
          }

          $('#this_area').after(output);
        }
      })
      .catch((error) => {
        console.log(error);
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      })
      .finally(() => {
        // 로딩 종료 시 스피너 숨김 (성공/실패 모두)
        setIsLoading(false);
        try {
          $("#overlay").attach();
        } catch (err) {
        }
      });
  }

  window.showSubscriptionSummary = (date) => {
    showSummaryModal(date);
  };

  // window.showSubscriptionDetail 함수 설정
  window.showSubscriptionDetail = (date, type) => {
    showDetailModal(date, type);
  };

  const showSummaryModal = (date) => {
    setSelectedDate(date);

    let branchCode = $('#s_branch_code option:selected').val() || '';
    // if (Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) < 9 && branchCode === '') branchCode = "_NONE_";

    // 모달 데이터 로드
    axios2
      .post(`/subscription/cal?date=${date}&s_branch_code=${branchCode}`)
      .then((response) => {
        const {code, message, result} = response?.data;
        if (code === 200) {
          setSummaryModalData(result);
          setSummaryModalOpen(true);
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  }

  // 상세 정보 모달 표시 함수
  const showDetailModal = (date, type, branchCode, prodType) => {
    let pBranchCode = branchCode || ($('#s_branch_code option:selected').val() || '');
    // if (Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) < 9 && pBranchCode === '') pBranchCode = "_NONE_";

    setSelectedDate(date);
    setModalType(type);

    // 타입에 따라 모달 제목 설정
    switch (type) {
      case 'total':
        setModalTitle(`${date} 결제 전체 내역`);
        break;
      case 'success':
        setModalTitle(`${date} 결제 성공 내역`);
        break;
      case 'fail':
        setModalTitle(`${date} 결제 중지 내역`);
        break;
      case 'cancel':
        setModalTitle(`${date} 결제 해지 내역`);
        break;
      case 'scheduled':
        setModalTitle(`${date} 결제 예정 내역`);
        break;
      default:
        setModalTitle(`${date} 결제 내역`);
    }

    // 모달 데이터 로드
    axios2
      .post(`/subscription/cal/detail?date=${date}&type=${type}&prod_type=${prodType || ''}&s_branch_code=${pBranchCode}`)
      .then((response) => {
        const {code, message, result} = response?.data;
        if (code === 200) {
          setModalData(result);
          setModalOpen(true);
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  }

  function onDate(_year, _month) {
    // 상태 업데이트
    setYear(_year);
    setMonth(_month);
    // displayYear와 displayMonth도 즉시 업데이트
    setDisplayYear(_year);
    setDisplayMonth(_month);
    // 리뉴 업데이트로 useEffect 트리거
    setRenew(Fn.getRenewTime());
  }

  return (
    <CmnCard onLogout={props.onLogout}>
      {/* 로딩 스피너 및 딤 처리 */}
      {isLoading && (
        <div style={spinnerStyles.loadingOverlay}>
          <div style={spinnerStyles.spinner}></div>
          <div style={spinnerStyles.loadingText}>데이터를 불러오는 중입니다</div>
        </div>
      )}

      <div className="d-flex justify-content-between m-3 flex-wrap">
        <div className="mt-2">
          {/* 타이틀에 displayYear와 displayMonth를 사용 */}
          <span className="h4 bold700">{displayYear}년 {displayMonth}월 구독결제 스케줄</span>
        </div>
        <div className="mt-2">
          <ul className="d-flex my-1">
            <li className="cal-years">
              <a className="cal-link" style={{cursor: "pointer"}} onClick={() => onDate(year - 1, 12)}>{year - 1}년</a>
            </li>
            {Array.from({length: 12}, (_, i) =>
              <li className="cal-item" key={i}>
                <a
                  className={Fn.parseInt(displayMonth) === (i + 1) ? "cal-link2" : "cal-link1"}
                  style={{cursor: "pointer"}}
                  onClick={(e) => {
                    e.preventDefault();
                    onDate(year, i + 1);
                  }}
                >
                  {i + 1}월
                </a>
              </li>
            )}
            <li className="cal-years">
              <a className="cal-link" style={{cursor: "pointer"}} onClick={() => onDate(year + 1, 1)}>{year + 1}년</a>
            </li>
          </ul>
        </div>

        <div className="d-flex mt-2">
          <div className="pr-1">
            <select className="form-select" id="s_branch_code">
            </select>
          </div>
          <button type="button" className="btn btn-sm btn-point" onClick={() => setSrchRenew(Fn.getRenewTime())}>검색</button>
        </div>
      </div>

      <div className="m-3 pb-2 table_list">
        <table className="view-rounded calender">
          <thead>
          <tr id="this_area">
            <th><span style={{color: "red"}}>일</span></th>
            <th>월</th>
            <th>화</th>
            <th>수</th>
            <th>목</th>
            <th>금</th>
            <th>토</th>
          </tr>
          </thead>
          <tbody>
          {/* 캘린더 내용은 jQuery로 추가됨 */}
          </tbody>
        </table>
      </div>

      {/* 상세 모달 */}
      <Modal
        isOpen={summaryModalOpen}
        style={{
          modal: {
            backgroundColor: 'transparent',
            margin: 0,
            padding: 0,
            alignItems: undefined,
            justifyContent: undefined,
            zIndex: 1000000000
          },
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'transparent'
          }
        }}
        onAfterOpen={() => {
          Fn.centerModal();
        }}
        onRequestClose={() => setSummaryModalOpen(false)}
        ariaHideApp={false}
      >
        <div className="pop_background" style={{zIndex: 1000000000}}>
          <div className="pop_box01 p_absolute_mid_pop" style={{maxWidth: 1000}}>
            <div className="POP_title">
              <h5><strong>통계 상세</strong></h5>
              <p className="closed">
                <button type="button" className="btn" onClick={() => setSummaryModalOpen(false)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </button>
              </p>
            </div>

            <div className="POP_cnt_box w-100">
              <table className="view-rounded sub_table_border text-center">
                <colgroup>
                  <col width="180px"/>
                  <col width="80px"/>
                  <col width="80px"/>
                  <col width="80px"/>
                  <col width="80px"/>
                  <col width="150px"/>
                </colgroup>
                <thead>
                <tr>
                  <th>지점</th>
                  <th>AnyPASS</th>
                  <th>BASIC</th>
                  <th>중지</th>
                  <th>해지</th>
                  <th>결제금액</th>
                </tr>
                </thead>
                <tbody>
                {summaryModalData?.list?.length > 0 ? (
                  summaryModalData.list.map((item, index) => (
                    <tr key={index}>
                      <td>{item.branch_name}</td>
                      <td><a onClick={() => showDetailModal(selectedDate, 'success', item.branch_code, 'AnyPASS')} style={{cursor: "pointer"}}>{Fn.numberWithCommas(Fn.parseInt(item.AnyPASS))}</a></td>
                      <td><a onClick={() => showDetailModal(selectedDate, 'success', item.branch_code, 'BASIC')} style={{cursor: "pointer"}}>{Fn.numberWithCommas(Fn.parseInt(item.BASIC))}</a></td>
                      <td><a onClick={() => showDetailModal(selectedDate, 'fail', item.branch_code)} style={{cursor: "pointer"}}>{Fn.numberWithCommas(Fn.parseInt(item.FAIL))}</a></td>
                      <td><a onClick={() => showDetailModal(selectedDate, 'cancel', item.branch_code)} style={{cursor: "pointer"}}>{Fn.numberWithCommas(Fn.parseInt(item.CANCEL))}</a></td>
                      <td><a onClick={() => showDetailModal(selectedDate, 'success', item.branch_code)} style={{cursor: "pointer"}}>{Fn.numberWithCommas(Fn.parseInt(item.AMT))}</a></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">데이터가 없습니다.</td>
                  </tr>
                )}
                {summaryModalData?.list?.length > 0 &&
                  <tr>
                    <th>전체</th>
                    <th><a onClick={() => showDetailModal(selectedDate, 'success', '', 'AnyPASS')} style={{cursor: "pointer"}}>{Fn.numberWithCommas(summaryModalData.list.reduce((acc, i) => acc + (i.AnyPASS || 0), 0))}</a></th>
                    <th><a onClick={() => showDetailModal(selectedDate, 'success', '', 'BASIC')} style={{cursor: "pointer"}}>{Fn.numberWithCommas(summaryModalData.list.reduce((acc, i) => acc + (i.BASIC || 0), 0))}</a></th>
                    <th><a onClick={() => showDetailModal(selectedDate, 'fail', '')} style={{cursor: "pointer"}}>{Fn.numberWithCommas(summaryModalData.list.reduce((acc, i) => acc + (i.FAIL || 0), 0))}</a></th>
                    <th><a onClick={() => showDetailModal(selectedDate, 'cancel', '')} style={{cursor: "pointer"}}>{Fn.numberWithCommas(summaryModalData.list.reduce((acc, i) => acc + (i.CANCEL || 0), 0))}</a></th>
                    <th><a onClick={() => showDetailModal(selectedDate, 'success', '')} style={{cursor: "pointer"}}>{Fn.numberWithCommas(summaryModalData.list.reduce((acc, i) => acc + (i.AMT || 0), 0))}</a></th>
                  </tr>
                }
                </tbody>
              </table>
            </div>
            <div className="text-center mt-2">
              <button type="button" className="btn btn-sm btn-dark" onClick={() => setSummaryModalOpen(false)}>닫기</button>
            </div>
          </div>
        </div>
      </Modal>

      {/* 상세 모달 */}
      <Modal
        isOpen={modalOpen}
        className={{
          base: 'top-tier-modal',
        }}
        style={{
          modal: {
            backgroundColor: 'transparent',
            margin: 0,
            padding: 0,
            alignItems: undefined,
            justifyContent: undefined,
            zIndex: 3000000000
          },
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'transparent',
            zIndex: 3000000000
          }
        }}
        onAfterOpen={() => {
          Fn.centerModal();
        }}
        onRequestClose={() => setModalOpen(false)}
        ariaHideApp={false}
      >
        <div className="pop_background2">
          <div className="pop_box01 p_absolute_mid_pop" style={{maxWidth: 1000}}>
            <div className="POP_title">
              <h5><strong>{modalTitle}</strong></h5>
              <p className="closed">
                <button type="button" className="btn" onClick={() => setModalOpen(false)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </button>
              </p>
            </div>

            <div className="POP_cnt_box w-100">
              <table className="view-rounded sub_table_border text-center">
                <colgroup>
                  <col width="60px"/>
                  <col width="130px"/>
                  <col width="110px"/>
                  <col width="180px"/>
                  <col width="*"/>
                  {modalType === 'fail' && <col width="250px"/>}
                </colgroup>
                <thead>
                <tr>
                  <th>No</th>
                  <th>회원ID</th>
                  <th>회원명</th>
                  <th>지점명</th>
                  <th>구독상품</th>
                  {(modalType === 'success' || modalType === 'total') && <th>결제액</th>}
                  {modalType === 'fail' && <th>중지사유</th>}
                </tr>
                </thead>
                <tbody>
                {modalData?.items?.length > 0 ? (
                  modalData.items.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.mbId}</td>
                      <td>{item.mbName}</td>
                      <td>{item.branchName}</td>
                      <td>{item.apPdtName}</td>
                      {(modalType === 'success' || modalType === 'total') && <td>{Fn.numberWithCommas(item.amt)}</td>}
                      {modalType === 'fail' && <td className="text-left">{item.failMsg}</td>}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={(modalType === 'fail' || modalType === 'success' || modalType === 'total') ? 6 : 5} className="text-center">데이터가 없습니다.</td>
                  </tr>
                )}
                </tbody>
              </table>
            </div>
            <div className="text-center mt-2">
              <button type="button" className="btn btn-sm btn-dark" onClick={() => setModalOpen(false)}>닫기</button>
            </div>
          </div>
        </div>
      </Modal>
    </CmnCard>
  );
};

export default AnalysisSubsCal;
